/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedBusinessAngelLoanListDto } from '../../models/backend-paginated-business-angel-loan-list-dto';

export interface VentureFundsBusinessAngelLoansList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function ventureFundsBusinessAngelLoansList(
  http: HttpClient,
  rootUrl: string,
  params?: VentureFundsBusinessAngelLoansList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelLoanListDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelLoansList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedBusinessAngelLoanListDto>;
    }),
  );
}

ventureFundsBusinessAngelLoansList.PATH = '/api/venture_funds/business-angel-loans/';
